<template>
	<div class="TagContainer">
		<div v-for="_ in noOfSkeletonTags" class="Tag Skeleton"></div>
	</div>
</template>

<script lang="ts" src="./SelectedFiltersSkeletonLoader.ts"></script>
<style lang="scss" src="./SelectedFiltersSkeletonLoader.scss" scoped></style>
